<template>
  <div class="reserve">
    <div class="reserve-form">
      <van-form @submit="search">
        <van-field
          readonly
          clickable
          name="picker"
          :value="searchForm.customerTypeShow"
          label="类别"
          right-icon="arrow"
          placeholder="点击选择类别"
          @click="showTypePicker = true"
        />
        <van-popup
          v-model="showTypePicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            value-key="label"
            :columns="typeList"
            @confirm="onTypeConfirm"
            @cancel="showTypePicker = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="searchForm.dateString"
          right-icon="arrow"
          label="发生日期"
          placeholder="点击选择发生日期"
          @click="dateShow = true"
        />
        <van-popup
          v-model="dateShow"
          position="bottom"
        >
          <van-calendar
            v-model="dateShow"
            :min-date="minDate"
            :default-date="searchForm.date"
            :allow-same-day="true"
            @confirm="onDateConfirm"
            type="range"
          />
        </van-popup>

        <van-field
          readonly
          clickable
          name="picker"
          :value="searchForm.doctorNameShow"
          label="分配医生"
          right-icon="arrow"
          placeholder="点击选择分配医生"
          @click="showDoctorPicker = true"
        />
        <van-popup
          v-model="showDoctorPicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            value-key="label"
            :columns="doctorList"
            @confirm="onDoctorConfirm"
            @cancel="showDoctorPicker = false"
          />
        </van-popup>

        <van-field
          v-model="searchForm.settle_min_amount"
          center
          clearable
          label="消费金额"
          placeholder=""
        >
          <template #input>
            <div class="reserve-table-money">
              <van-field
                v-model="searchForm.settle_min_amount"
                center
                clearable
                label=""
                placeholder=""
              >

              </van-field>
              至<van-field
                v-model="searchForm.settle_max_amount"
                center
                clearable
                label=""
                placeholder=""
              >

              </van-field>
            </div>
          </template>
        </van-field>
        <van-field
          v-model="searchForm.customer_name"
          center
          clearable
          label="客户姓名"
          placeholder=""
        >

        </van-field>

        <div style="margin: 16px;">
          <el-button
            type="primary"
            size="small"
            round
            @click="search"
            :loading="loading"
          >搜索</el-button>
        </div>

      </van-form>
      <div
        class="reserve-title"
        v-html="title"
      >
      </div>
    </div>
    <div class="reserve-table-mobile">
      <van-collapse
        v-model="activeNames"
        accordion
      >
        <van-collapse-item
          v-for="(item, index) in tableData"
          :name="index"
          :key="index"
        >
          <template #title>
            <div class="reserve-table-mobile-item-title">
              <div class="reserve-table-mobile-item-title-left">
                <div class="reserve-table-mobile-item-title-name">
                  {{ item.customer_name_str }} {{ item.customer_level_name ? `(${item.customer_level_name})` : '' }} {{ item.visitType }}
                </div>
                <div>
                  {{ item.card_no_str }}
                </div>
              </div>
              <div class="reserve-table-mobile-item-title-right">
                <div>
                  {{ item.assign_doctor }}
                </div>
                <div>

                </div>

              </div>
            </div>
          </template>

          <div class="reserve-table-mobile-item-content">
            <!-- <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                预约日期
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.appointmentDate  }}
              </div>
            </div>
            <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                预约时间段
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.startTime  }} - {{  item.endTime  }}
              </div>
            </div> -->
            <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                类别
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.customer_type  }}
              </div>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="reserve-table-mobile-item-content-infor">
                  <div class="reserve-table-mobile-item-content-lable">
                    发生日期
                  </div>
                  <div class="reserve-table-mobile-item-content-text">
                    {{  moment(item.create_date).format('YYYY-MM-DD')  }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="reserve-table-mobile-item-content-infor">
                  <div class="reserve-table-mobile-item-content-lable">
                    消费金额
                  </div>
                  <div class="reserve-table-mobile-item-content-text">
                    {{  item.settle_amount  }}
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                客户来源
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.customer_source  }}
              </div>
            </div>

            <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                挂账机构
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.buyer_company  }}
              </div>
            </div>
            <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                产品名称
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.meal_name  }}
              </div>
            </div>
            <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable flex-width-110">
                除体检外看诊科室
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.visit_department  }}
              </div>
            </div>
            <div class="reserve-table-mobile-item-content-infor">
              <div class="reserve-table-mobile-item-content-lable">
                备注
              </div>
              <div class="reserve-table-mobile-item-content-text">
                {{  item.remark  }}
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>

    <!-- <div
      v-else
      class="reserve-table"
    >
      <el-table
        :data="tableData"
        height="100%"
        border
        style="width: 100%"
        size="small"
        row-key="appointmentNo"
      >
        <el-table-column
          prop="appointmentDate"
          label="预约日期"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="预约时段"
          width="100px"
        >
          <template slot-scope="scope">
            {{ scope.row.startTime }}-{{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="patientName"
          label="姓名"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          width="50px"
        >
        </el-table-column>
        <el-table-column
          prop="ageDesc"
          label="年龄"
          width="50px"
        >
        </el-table-column>

        <el-table-column
          prop="levelDesc"
          label="会员等级"
          width="70px"
        >
        </el-table-column>
        <el-table-column
          prop="itemName"
          label="科室"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="visitType"
          label="就诊原因"
          min-width="170"
        >
        </el-table-column>
        <el-table-column
          prop="packagename"
          label="套餐名称"
          min-width="170"
        >
        </el-table-column>
      </el-table>
    </div> -->
  </div>
</template>

<script>
import moment from "moment";
import getUserInfo from "@/models/userInfo";
import hisService from "@/apis/his/index.js";
// import { Toast } from "vant";
// import { MessageBox, Message } from "element-ui";

export default {
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(
        navigator.userAgent
      ),
      minDate: new Date(moment().subtract(1, "years").format("YYYY-MM-DD")),
      typeList: [
        {
          label: "全部",
          value: "",
        },
      ],
      activeNames: [],
      title: "",
      dateShow: false,
      showTypePicker: false,
      showDoctorPicker: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() + 86400000 < Date.now();
        },
      },
      searchForm: {
        date: [
          // new Date(moment().subtract(1, "months").format("YYYY-MM-DD")),
          // new Date(moment().format("YYYY-MM-DD")),
        ],
        assign_doctor: "",
        doctorNameShow: "全部",
        customer_type: "",
        customerTypeShow: "全部",
      },
      tableData: [],

      doctorList: [
        {
          label: "全部",
          value: "",
        },
      ],
      loading: false,
    };
  },
  watch: {
    searchForm: {
      handler(newVal) {
        if (newVal.date[0]) {
          this.searchForm.dateString = `${moment(newVal.date[0]).format(
            "YYYY-MM-DD"
          )}至${moment(newVal.date[1]).format("YYYY-MM-DD")}`;
        } else {
          this.searchForm.dateString = "全部";
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    this.init();
    this.queryMerchantCustomerDict();
    const userInfo = await getUserInfo();
    // this.doctorList.push({
    //   label: userInfo.user_name,
    //   value: userInfo.user_name,
    // });

    this.currentUserInfo = userInfo;
    this.getTableList();
  },
  methods: {
    moment,
    QueryMerchantCustomerList() {},
    onDateConfirm(date) {
      this.searchForm.date = date;
      this.dateShow = false;
    },
    onTypeConfirm(item) {
      const { searchForm } = this;
      searchForm.customerTypeShow = item.label;
      searchForm.customer_type = item.value;
      this.showTypePicker = false;
    },
    onDoctorConfirm(item) {
      const { searchForm } = this;
      searchForm.assign_doctor = item.value;
      searchForm.doctorNameShow = item.label;
      this.showDoctorPicker = false;
    },
    init() {},
    search() {
      // const { searchForm } = this;
      // const date = searchForm.date;
      // if (moment(date[1]).isAfter(moment(date[0]).add(1, "months"))) {
      //   Message({
      //     message: "最多查询时间范围为一个月",
      //     type: "warning",
      //   });
      //   return;
      // }
      this.getTableList();
    },
    queryMerchantCustomerDict() {
      hisService.queryMerchantCustomerDict().then((res) => {
        res.customerType.forEach((item) => {
          item.label = item.key;
        });
        res.assignDoctor.forEach((item) => {
          item.label = item.key;
        });
        this.doctorList.push(...res.assignDoctor);
        this.typeList.push(...res.customerType);
        console.log(res);
      });
    },
    getTableList() {
      const { searchForm } = this;
      const params = {
        ...searchForm,
        settle_min_amount: searchForm.settle_min_amount
          ? Number(searchForm.settle_min_amount)
          : null,
        settle_max_amount: searchForm.settle_max_amount
          ? Number(searchForm.settle_max_amount)
          : null,
      };
      if (searchForm.date[0]) {
        params.create_start_date = moment(searchForm.date[0]).format(
          "YYYY-MM-DD"
        );
        params.create_end_date = moment(searchForm.date[1]).format(
          "YYYY-MM-DD"
        );
      }
      this.loading = true;
      hisService
        .queryMerchantCustomerList(params)
        .then((res) => {
          console.log(res);
          res.list.forEach((item) => {
            item.customer_name_str = this.hideSensitiveInfo(item.customer_name);
            item.card_no_str = this.hideCardSensitiveInfo(item.card_no);
          });
          this.tableData = res.list;
          this.title = `本次统计人次: ${res.list.length}`;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    hideCardSensitiveInfo(str) {
      if (!str) return str;
      if (str.length < 4) {
        return "*".repeat(str.length);
      }
      let result = str.slice(0, 3); // 保留前三个字符
      for (let i = 3; i < str.length - 1; i++) {
        result += "*"; // 将中间的字符替换为'*'
      }
      result += str[str.length - 1]; // 保留最后一个字符
      return result;
    },
    hideSensitiveInfo(str) {
      let result = "";
      let regex = /[\u4E00-\u9FA5]/g; // 匹配中文字符的正则表达式
      let match = str.match(regex);
      if (match) {
        // 如果字符串包含中文字符
        if (str.length > 3) {
          // 如果中文字符数量超过1个，则将第二个字符替换为*，并将中间的字符替换为*
          result = str.replace(
            str.substring(1, str.length - 2),
            "*".repeat(str.length - 2)
          );
        } else {
          // 如果中文字符数量为1个，则只替换第二个字符为*
          result = str.replace(match[1], "*");
        }
      } else {
        // 如果字符串不包含中文字符，就假设它是英文，并替换第2-6位为*
        result = str.replace(str.substring(1, 6), "*".repeat(5));
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
.reserve {
  height: 100%;
  overflow: hidden;
  // overflow: scroll;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .el-button {
    width: 100%;
    background-color: #e7635e;
    border: none;
  }
  .reserve-title {
    margin-bottom: 10px;
    color: #e7635e;
    min-height: 40px;
  }
  .reserve-table {
    flex: 1;
    overflow: hidden;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-date-editor.el-input__inner {
    width: 220px;
  }
  .reserve-table-mobile {
    flex: 1;
    overflow: scroll;
  }
  .van-cell {
    align-items: center;
  }
  .reserve-table-mobile-item-title-name {
    font-size: 15px;
    font-weight: 600;
  }
  .reserve-table-mobile-item-title {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    align-items: center;
    .reserve-table-mobile-item-title-right {
      text-align: right;
      flex-shrink: 0;
      font-size: 15px;
    }
  }
  .reserve-table-mobile-item-content-infor {
    display: flex;
    padding: 3px 0;
    .reserve-table-mobile-item-content-lable {
      width: 60px;
      flex-shrink: 0;
      color: #999;
    }
    .flex-width-110 {
      width: 110px;
    }
    .reserve-table-mobile-item-content-text {
      text-align: left;
      color: #000;
    }
  }
  // .van-cell::after {
  //   display: none;
  // }
  .van-collapse-item--border::after {
    border-top: 4px solid #eee;
    left: 0;
    right: 0;
  }
  .van-collapse-item__content {
    // padding-top: 0;
    font-size: 12px;
  }
}
.reserve-table-money {
  display: flex;
  input {
    text-align: center;
  }
  .van-cell {
    padding: 0;
  }
  .van-cell::after {
    content: "";
    border-bottom: 0;
  }
}
</style>